const server_url = process.env.REACT_APP_API_SERVER_URL ||
"https://api.kifaytihealth.com/api1/api";
// const server_url = "http://localhost:3000/api";

export { server_url };
export const adminEmail = "superadmin@kifaytihealth.com";
